import defs from './_core/defs.js';
import { uniqueNodes } from './_dom/index.js';
import selectNodes, { scopeToSandbox } from './bindnode/_selectnodes.js';
import checkObjectType from './_helpers/checkobjecttype.js';
import forEach from './_helpers/foreach.js';
var customSelectorTestReg = /:sandbox|:bound\(([^(]*)\)/;
export default function selectAll(object, selector) {
  if (typeof this === 'object' && this.isMatreshka) {
    // when context is Matreshka instance, use this as an object and shift other args
    selector = object;
    object = this;
  } else {
    // throw error when object type is wrong
    checkObjectType(object, 'selectAll or $');
  }
  // the selector includes "custom" things like :sandbox or :bound(KEY)
  if (customSelectorTestReg.test(selector)) {
    return selectNodes(object, scopeToSandbox(selector));
  }
  var def = defs.get(object);
  var result = [];
  if (!def || typeof selector !== 'string') {
    return result;
  }
  var propDef = def.props.sandbox;
  if (!propDef) {
    return result;
  }
  var bindings = propDef.bindings;
  if (bindings) {
    // iterate over all bindings and add found nodes
    forEach(bindings, function (_ref) {
      var node = _ref.node;
      var selected = node.querySelectorAll(selector);
      result = uniqueNodes(result, selected);
    });
  }
  return result;
}